import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, BookOpen, Camera, Users } from 'lucide-react';

const focusCards = [
  {
    icon: Heart,
    title: 'Real Wedding Stories',
    description: 'From couples across Malta and beyond, honest, heartfelt stories that celebrate every unique love journey.',
    link: '/wedding-stories',
  },
  {
    icon: BookOpen,
    title: 'Editorial Features',
    description: 'Inspiration covering fashion, beauty, planning, d\u00e9cor, and venues to guide every step of your wedding journey.',
    link: '/tips-inspiration',
  },
  {
    icon: Camera,
    title: 'Styled Shoots',
    description: 'Creative collaborations with leading and emerging wedding professionals that push the boundaries of beauty.',
    link: '/the-magazine',
  },
  {
    icon: Users,
    title: 'Curated Vendor Guide',
    description: 'Connecting couples with trusted suppliers, carefully selected professionals you can rely on.',
    link: '/partners',
  },
];

const OurFocusSection = () => {
  return (
    <section className="py-24 bg-white" data-testid="our-focus-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <p
            className="text-base md:text-lg mb-4 italic"
            style={{ fontFamily: '"Playfair Display", serif', color: '#DE92A9' }}
          >
            Our Focus
          </p>
          <h2
            className="text-4xl md:text-5xl lg:text-6xl tracking-tight mb-6"
            style={{ fontFamily: '"Playfair Display", serif', color: '#2C2C2C' }}
          >
            What We Do
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {focusCards.map((card) => (
            <Link
              key={card.title}
              to={card.link}
              className="group p-8 rounded-xl border border-[#E5E0DA] transition-all duration-300 hover:shadow-lg hover:border-[#DE92A9]/20 block"
              style={{ backgroundColor: '#FDFCFB' }}
              data-testid={`focus-card-${card.title.toLowerCase().replace(/\s+/g, '-')}`}
            >
              <div
                className="w-12 h-12 rounded-full flex items-center justify-center mb-6"
                style={{ backgroundColor: '#DE92A9' }}
              >
                <card.icon size={20} className="text-white" />
              </div>
              <h3
                className="text-xl mb-3 group-hover:text-[#DE92A9] transition-colors"
                style={{ fontFamily: '"Playfair Display", serif', color: '#2C2C2C' }}
              >
                {card.title}
              </h3>
              <p className="text-sm leading-relaxed" style={{ color: '#757B7F' }}>
                {card.description}
              </p>
            </Link>
          ))}
        </div>

        <p
          className="text-center text-base max-w-3xl mx-auto mt-14 leading-relaxed"
          style={{ color: '#757B7F' }}
        >
          Our focus is on storytelling, strong visuals, and thoughtful content that reflects both timeless elegance and modern romance.
        </p>
      </div>
    </section>
  );
};

export default OurFocusSection;
